export default "__VITE_ASSET__115c77cd__"